<template>
  <div class="tool-bar">
    <h3>Schedule</h3>
    <div class="date-selector">
      <div
        class="nav-prev"
        @click="goPrev"
      >
        <fa icon="arrow-left" />
      </div>
     
      <div
        v-for="(date, index) in dates"
        :key="date"
        ref="dateElements"
        class="date"
        :style="{left:index * 100 + '%'}"
      >
        {{ date }}
      </div>			
      
      
      <div class="nav-right"
	     @click="goNext">
        <fa icon="arrow-right" />
      </div>	
    </div>
  </div>


  <button @click="addTrack()">
    Add track
  </button>	
  <div class="wrap">
    <!-- <div class="left">
      <DayPilotNavigator
        id="nav"
        ref="navigator"
        :config="navigatorConfig"
      />
    </div> -->
    <div class="content">
      <DayPilotCalendar
        id="dp"
        ref="calendar"
        :config="calendarConfig"
      />
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, reactive} from 'vue';
import { DayPilot, DayPilotCalendar, DayPilotNavigator } from '@daypilot/daypilot-lite-vue'


const calendar = ref(null);
const navigator = ref(null);
const dates = ref(['2023-08-01','2023-08-09','2023-08-10'])
const dateElements = ref([]);		

// const navigatorConfig = {
// 	showMonths: 3,
// 	skipMonths: 3,
// 	selectMode: "Day",
// 	startDate: "2023-08-01",
// 	selectionDay: "2023-08-01",
// 	onTimeRangeSelected: args => {
// 		calendarConfig.startDate = args.day;
// 		console.log("args",args.day.value);
// 	}
// };

const calendarConfig = reactive({
	viewType: "Resources",
	startDate: "2023-08-01",
	timeRangeSelectedHandling: "Enabled",
	onTimeRangeSelected: async (args) => {
				
		await createEvent(args.start, args.end, args.resource);

		calendar.value.control.clearSelection();
	},
	onEventClick: (args) => {
		editEvent(args.e);
	},
	eventDeleteHandling: "Disabled",
	onEventMoved: (args) => {
		console.log("Event moved", args.e);
	},
	onEventResized: (args) => {
		console.log("Event resized", args.e);
	},
});

const loadEvents = () => {
	// placeholder for an HTTP call
	const events = [
		{
			id: 1,
			start: "2023-08-01T09:00:00",
			end: "2023-08-01T11:00:00",
			resource: "R1",
			text: "Event 1",
			barColor: "#6aa84f",
		},
		// {
		// 	id: 2,
		// 	start: "2023-08-01T13:00:00",
		// 	end: "2023-08-01T16:00:00",
		// 	resource: "R3",
		// 	text: "Event 2",
		// 	barColor: "#f1c232",
		// },
		// {
		// 	id: 3,
		// 	start: "2023-08-01T13:30:00",
		// 	end: "2023-08-01T16:30:00",
		// 	resource: "R2",
		// 	text: "Event 3",
		// 	barColor: "#cc4125",
		// },
		// {
		// 	id: 4,
		// 	start: "2023-08-01T10:30:00",
		// 	end: "2023-08-01T12:30:00",
		// 	resource: "R2",
		// 	text: "Event 4",
		// },
		// {
		// 	id: 5,
		// 	start: "2023-08-10T10:30:00",
		// 	end: "2023-08-10T12:30:00",
		// 	resource: "R2",
		// 	text: "Event 5",
		// },
		// {
		// 	id: 6,
		// 	start: "2023-08-18T10:30:00",
		// 	end: "2023-08-18T12:30:00",
		// 	resource: "R2",
		// 	text: "Event 6",
		// },
		// {
		// 	id: 7,
		// 	start: "2023-08-19T10:30:00",
		// 	end: "2023-08-19T12:30:00",
		// 	resource: "R2",
		// 	text: "Event 7",
		// },
	];
	calendar.value.control.update({events});
	// navigator.value.control.update({events});
};

const columns = [{name: "Track 1", id: "R1"}];
const loadResources = () => {
	// columns = [
	// 	{name: "Resource 1", id: "R1"},
	// 	 {name: "Resource 2", id: "R2"},
	// 	{name: "Resource 3", id: "R3"},
	// 	{name: "Resource 4", id: "R4"},
	// 	{name: "Resource 5", id: "R5"},
	// 	{name: "Resource 6", id: "R6"},
	// ];
	calendar.value.control.update({columns});
};

  const count = ref(1);
const addTrack = function(){
	// alert("addd");
	count.value++;
	      
	      columns.push({name: "Track "+count.value, id: "R"+count.value});
	loadResources();
}
		


const editEvent = async (e) => {
	const form = [
		{name: "Text", id: "text"},
		{name: "Start", id: "start", type: "datetime", disabled: true},
		{name: "End", id: "end", type: "datetime", disabled: true},
		{name: "Resource", id: "resource", type: "select", options: calendar.value.control.columns.list}
	];
	const data = e.data;
	const modal = await DayPilot.Modal.form(form, data);
	if (modal.canceled) {
		return;
	}

	calendar.value.control.events.update(modal.result);
};

const createEvent = async (start, end, resource) => {
	// console.log(start, end, resource);
	const form = [
		{name: "Text", id: "text"},
		{name: "Start", id: "start", type: "datetime", disabled: true},
		{name: "End", id: "end", type: "datetime", disabled: true},
		{name: "Resource", id: "resource", type: "select", options: calendar.value.control.columns.list}
	];
	const data = {
		start,
		end,
		resource,
		id: DayPilot.guid()
	};
	const modal = await DayPilot.Modal.form(form, data);
	if (modal.canceled) {
		return;
	}

	const e = modal.result;
	calendar.value.control.events.add(e);
};

onMounted(() => {
	loadResources();
	loadEvents();
	slideImage()
	console.log("dateElement",dateElements.value)
});


// date selector

let counter = ref(0);   
let nav = ref(''); 

const slideImage = ()=>{
	dateElements.value.forEach((slide,index)=>{
		slide.style.transform=`translateX(-${counter.value * 100}%)`;
		console.log(`translateX(-${counter.value * 100}%)`)
		console.log("counter.value",counter.value);
	})
	console.log(dateElements.value[counter.value].textContent);
	calendarConfig.startDate = dateElements.value[counter.value].textContent;
}



const goPrev = ()=>{
	counter.value--;
	nav.value = 'prev';
	slideImage();
}

const goNext = ()=>{
	nav.value = 'next';
	counter.value++;
	slideImage();
}
	

</script>

<style>
/* date selector */
.tool-bar{box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;padding: 12px 18px;border-radius: 5px;
display: flex;align-items: center;justify-content: space-between;}
.tool-bar h3{display: inline-block;}
.date-selector{
	position: relative;
	min-width: 200px;
    height: 37px;
    background-color: #f0f0f0;
    overflow: hidden;
    border-radius: 5px;}
.date{position: absolute;
    left: 0;
    right: 0;
    min-width: 200px;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;}	

.nav-prev,.nav-right{
	position: absolute;
     width: max-content;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;padding: 0 12px;cursor: pointer;
	z-index: 1020;}
    
	.nav-prev{left: 0;}
	.nav-right{right: 0;}
.wrap {
    display: flex;
}

.left {
    margin-right: 10px;
}

.content {
    flex-grow: 1;
}

.navigator_default_busy.navigator_default_cell {
    border-bottom: 4px solid #ee4f2ecc;
    box-sizing: border-box;
}

</style>
